import { PalletManualShippingCommand } from "./pallet-manual-shipping-command";
import { PalletPickupSlotShippingCommand } from "./pallet-pickup-slot-shipping-command";

export enum PalletShipCommandMode {
    Manual = 1,
    PickupSlot = 2,
}

export type AnyOfPalletShipCommand = PalletManualShippingCommand | PalletPickupSlotShippingCommand;

export interface IPalletShipCommand {
    mode: PalletShipCommandMode;
    palletIdList: string[];
}
